/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} My_Weighings_PartialInputs */

const vi_my_weighings_partial = /** @type {(inputs: My_Weighings_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang hiện ${i?.shown}/${i?.total} phiếu gần nhất — thu hẹp khoảng ngày để xem đủ.`)
};

/**

* @param {My_Weighings_PartialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_partial = /** @type {((inputs: My_Weighings_PartialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_PartialInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_partial(inputs)
});